import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {MembershipModel} from './Membership.model';

@injectable()
export class MembershipFactory
  implements BaseDomainFactory<MembershipModel, MembershipModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: MembershipModel.Props): MembershipModel {
    return this.modelsRegistry.put(new MembershipModel(props));
  }
}
